import React from 'react';
import { Navigate, Route } from 'react-router-dom';

import { UserRolesEnum } from 'commons/types/user.roles.enum';
import PrivateRoute from 'commons/utils/privateRoute';
import { AssignSTOPickItemPage } from 'pages/sto-pick/assign-sto-item';
import { STOPickItemPage } from 'pages/sto-pick/sto-pick-item';
import { STOPickListPage } from 'pages/sto-pick/sto-pick-list';
import { STOPickSummaryPage } from 'pages/sto-pick/sto-pick-summary';

import { STO_PICK_ROUTE_ROOT, STO_PICK_ROUTES } from './constants';

export const useSTOPickRouter = (): React.JSX.Element => (
  <Route
    path={STO_PICK_ROUTE_ROOT}
    element={
      <PrivateRoute
        roles={[
          UserRolesEnum.SUPER_ADMIN,
          UserRolesEnum.ADMIN,
          UserRolesEnum.REPLENISH,
        ]}
      />
    }
  >
    <Route path={STO_PICK_ROUTES.ASSIGN} element={<AssignSTOPickItemPage />} />
    <Route path={STO_PICK_ROUTES.LIST} element={<STOPickListPage />} />
    <Route path={STO_PICK_ROUTES.ITEM} element={<STOPickItemPage />} />
    <Route path={STO_PICK_ROUTES.SUMMARY} element={<STOPickSummaryPage />} />
    <Route
      path={STO_PICK_ROUTES.STO_PICK}
      element={<Navigate to={STO_PICK_ROUTES.ASSIGN} />}
    />
  </Route>
);
